import { GenericLabel } from '@com-delta-idp/mnx-utils';
import {
  CardCarouselBanner,
  BannerImage
} from '../../models/banner.interfaces';

export const BannerImageTrustClubPlatiniumCardMocks: BannerImage = {
  alt: 'Delta SkyMiles Trust Club Platinum Card',
  src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/japan-trust-club-platinum-card.png',
  show: true,
  position: 'right'
};

export const BannerContentTrustClubPlatiniumCardMocks: GenericLabel = {
  title: 'Delta SkyMiles Trust Club Platinum VISA Card',
  subtitle: ''
};

export const BannerTrustClubPlatiniumCardMocks: CardCarouselBanner = {
  labels: BannerContentTrustClubPlatiniumCardMocks,
  image: BannerImageTrustClubPlatiniumCardMocks
};
